const addNode = (tree, parentId, node) => {
  if (tree._id === parentId) {
    tree.children.push({ ...node, children: [] })
  } else if (tree.children.length > 0) {
    for (let i = 0; i < tree.children.length; i++) {
      addNode(tree.children[i], parentId, node)
    }
  } else {
    return false
  }
}

const removeNode = (tree, _id) => {
  if (tree._id === _id) {
    return true
  } else if (tree.children.length > 0) {
    for (let i = 0; i < tree.children.length; i++) {
      const result = removeNode(tree.children[i], _id)
      if (result === true) {
        tree.children = [...tree.children.filter(child => child._id !== _id)]
      }
    }
  } else {
    return false
  }
}

const editNode = (tree, _id, data) => {
  if (tree._id === _id) {
    return true
  } else if (tree.children.length > 0) {
    for (let i = 0; i < tree.children.length; i++) {
      const result = editNode(tree.children[i], _id, data)
      if (result === true) {
        const newChildren = tree.children.map(child => {
          return child._id === _id ? { ...child, ...data } : child
        })
        tree.children = newChildren
      }
    }
  } else {
    return false
  }
}

const findNode = (tree, _id) => {
  if (tree._id === _id) {
    return tree
  } else if (tree.children.length > 0) {
    for (let i = 0; i < tree.children.length; i++) {
      const result = findNode(tree.children[i], _id)

      if (!!result) return result
    }

    return undefined
  } else {
    return undefined
  }
}

const findNextSibiling = (tree, _id) => {
  if (tree._id === _id) {
    return true
  } else if (tree.children.length > 0) {
    for (let i = 0; i < tree.children.length; i++) {
      const result = findNextSibiling(tree.children[i], _id)

      if (!!result) return tree.children[i + 1] || undefined
    }

    return undefined
  } else {
    return undefined
  }
}

const arrayToTree = (list) => {
  let map = {}
  let category
  let roots = []
  let i

  for (i = 0; i < list.length; i += 1) {
    map[list[i]._id] = i
    list[i].children = []
  }

  for (i = 0; i < list.length; i += 1) {
    category = list[i]

    category.parentId
      ?
      map[category.parentId] !== undefined &&
      list[map[category.parentId]].children.push(category)
      :
      roots.push(category)
  }

  return roots
}

const treeMethods = {
  findNode,
  arrayToTree,
  editNode,
  addNode,
  removeNode,
  findNextSibiling
}

export default treeMethods